const PREFIX = 'place_'
export const LOADING = PREFIX + 'LOADING'
export const UPDATE_ALL = PREFIX + 'UPDATE_ALL'
export const UPDATE_BY_ID = PREFIX + 'UPDATE_BY_ID'

const PREFIX_SITE = 'place_site_'
export const LOADING_SITE = PREFIX_SITE + 'LOADING'
export const UPDATE_ALL_SITES_BY_PLACE = PREFIX_SITE + 'UPDATE_ALL'
export const UPDATE_SITES_BY_PLACE = PREFIX_SITE + 'UPDATE_BY_ID'